import { css } from 'design'
import { VideoOffIcon } from 'images/index'
import { Card } from 'primitives/card'
import { Stack, StackProps } from 'primitives/containers'
import React, { useContext } from 'react'

import { DevicesContext } from '../../contexts/devices_context'
import { MicrophoneMutedIcon } from '../../images/index'
import { OnboardingButton } from '../onboarding/onboarding_button'

type Props = {
  audio: boolean
  video: boolean
  ask: any // your custom function that calls getUserMedia inside
  children?: JSX.Element
} & StackProps

export const DevicePermissionsPrompt = ({
  audio,
  video,
  ask,
  children,
  ...props
}: Props) => {
  const { permissionStates, pendingPermissionRequests } =
    useContext(DevicesContext)

  const pendingPermission =
    (audio && pendingPermissionRequests.microphone) ||
    (video && pendingPermissionRequests.camera)
  const permissionPrompt =
    (audio && permissionStates.microphone === 'prompt') ||
    (video && permissionStates.camera === 'prompt')
  const permissionBlocked =
    (audio && permissionStates.microphone === 'denied') ||
    (video && permissionStates.camera === 'denied')

  const devices =
    audio && video ? 'camera & microphone' : video ? 'camera' : 'microphone'

  return permissionPrompt || permissionBlocked ? (
    <Stack
      as={'section'}
      gap={5}
      // eslint-disable-next-line
      // @ts-ignore
      css={{ justifyContent: 'center' }}
      {...props}
    >
      <>
        <span className={headerStyles()}>
          {permissionBlocked
            ? `Please grant ${devices} permissions.`
            : `To record ${
                video ? 'video' : 'audio'
              }, your browser will need to request access to your ${devices}.`}
        </span>
        <Card className={cardStyles()}>
          {video ? <VideoOffIcon /> : <MicrophoneMutedIcon />}
          <span className={headerStyles()}>
            {`${video ? 'Cam & Mic are' : 'Mic is'} not active`}
          </span>
        </Card>
        {!pendingPermission && !permissionBlocked && (
          <OnboardingButton className={buttonStyles()} onClick={ask}>
            Request Permissions
          </OnboardingButton>
        )}
      </>
    </Stack>
  ) : (
    children || null
  )
}

const headerStyles = css({
  color: '$grey500 !important',
  fontSize: 16,
  textAlign: 'center',
})

const buttonStyles = css({
  maxWidth: 250,
  alignSelf: 'center',
})

const cardStyles = css({
  backgroundColor: 'white !important',
  aspectRatio: '1/1',
  color: '$grey500 !important',
  svg: {
    width: 100,
    height: 100,
    fill: '$grey500',
  },
  alignSelf: 'center !important',
  width: '100% !important',
  maxWidth: 800,
})
